import React from 'react';
import './BrandLogo.css';

// Vector interpretation of the selected Signal identity; inherits its surface color.
export default function BrandLogo({ className = '' }) {
  return <span className={`quantros-logo ${className}`} role="img" aria-label="Quantros">
    <svg viewBox="0 0 100 90" aria-hidden="true" focusable="false">
      <g fill="none" stroke="currentColor" strokeWidth="22" strokeLinecap="round">
        <path d="M16 61 L22 43" />
        <path d="M41 74 L55 31" />
        <path d="M72 57 L87 12" />
      </g>
    </svg>
    <span aria-hidden="true">quantros</span>
  </span>;
}
